import SHIPPING_METHODS from '../../../constants/ShippingMethods';
import { IDeliveryOption } from '../../../domain/entities/Transaction/Transaction';

const deliveryOptionsMapper = {
  response(deliveryOptions: IDeliveryOption[]) {
    return deliveryOptions?.map(deliveryOption => {
      const { defaultShipMethods, shipMethodIds } = deliveryOption;
      return {
        ...deliveryOption,
        defaultShipMethods: defaultShipMethods?.map(
          item => (
            {
              shipMethodId: item.shipMethodId as SHIPPING_METHODS,
              targetCountryId: item.targetCountryId,
            }),
        ) || [],
        shipMethodIds: shipMethodIds?.map(id => id) as SHIPPING_METHODS[],
      };
    });
  },
};

export default deliveryOptionsMapper;